module.exports = __webpack_public_path__ + "img/restaurant-atmosphere.f66e7a6d.svg";